import * as fetch from "../utils/action";
import { formatDateObject } from "formats/date";
import { getEnumeration } from "utils/formatUtils/enumeration";
import {
  stateOptions,
  colorOtions,
  packOptions,
  storageOptions,
  deliverOptions,
  specificationModelOptions,
} from "json/options";
let actions = {
  getReportMessage(ctx, id) {
    return fetch.getReportMessage(id).then((res) => {
      let result = res.data;
      let examination = result.examination;
      let entrustContent = result.entrustContent;
      let delivery = result.delivery || {};
      let partyAInformation = result.partyAInformation || {}
      partyAInformation.companyName = partyAInformation.companyName.indexOf('_') > -1 ? partyAInformation.companyName.split("_")[0] : partyAInformation.companyName
      result.entrustContentNew = {};
      let cost = result.cost || {};
      result.costShow = {};
      // result.costShow.amount =(cost.amount && cashCount(cost.amount, true, 2, "¥")) || "";
      result.costShow.amount = cost.amount || "";
      // result.costShow.emergencyAmount =
      //   (cost.emergencyAmount &&
      //     cashCount(cost.emergencyAmount, true, 2, "¥")) ||
      //   "";
      result.costShow.emergencyAmount = cost.emergencyAmount || "";
      result.costShow.examinationAmount = cost.examinationAmount || "";
      result.costShow.other = cost.other || "";
      // result.costShow.examinationAmount =
      //   (cost.examinationAmount &&
      //     cashCount(cost.examinationAmount, true, 2, "¥")) ||
      //   "";
      // result.costShow.other =
      //   (cost.other && cashCount(cost.other, true, 2, "¥")) || "";
      result.costShow.remark = cost.remark;
      if (examination && examination.length) {
        examination.forEach((item) => {
          // item.orderProduct_date =
          //     item.orderProductDate &&
          //     formatDateObject(item.orderProductDate, "YYYY-MM-DD");
          item.colorShow = getEnumeration(item.color, colorOtions);
          item.shapeShow = getEnumeration(item.shape, stateOptions);
          item.packShow = getEnumeration(item.pack, packOptions);
          item.storageShow = getEnumeration(item.storage, storageOptions);
          item.specification_model = getEnumeration(
            item.specificationModel,
            specificationModelOptions
          );
          item.examinationItem = "";
          if (item.examinationItems && item.examinationItems.length) {
            item.examinationItems.forEach((etem) => {
              item.examinationItem = item.examinationItem ?
                item.examinationItem + "/" + etem :
                etem;
            });
          }
        });
      }
      result.examinationNew = actions.getSampleMessage(examination);
      if (entrustContent && entrustContent.length) {
        result.entrustContentNew.examinationCredentials = [];
        result.entrustContentNew.examinationItem = [];
        result.entrustContentNew.deviateInfo = [];
        result.entrustContentNew.deviate = [];
        result.entrustContentNew.deviateInfo_show =
          entrustContent[0] && entrustContent[0].deviateInfo; //后端已拼接
        entrustContent.forEach((item) => {
          result.entrustContentNew.examinationCredentials = actions.arrayData(
            result.entrustContentNew,
            item,
            "examinationCredentials"
          );
          result.entrustContentNew.examinationItem = actions.arrayData(
            result.entrustContentNew,
            item,
            "examinationItem"
          );
          result.entrustContentNew.deviate = actions.arrayData(
            result.entrustContentNew,
            item,
            "deviate"
          );
        });
      }
      result.entrustContentNew.deviate_text =
        result.entrustContentNew.deviate.indexOf(true) > -1 ? "是" : "否";

      // result.entrustContentNew.deviate = result.entrustContentNew.deviate
      //   ? "是"
      //   : "否";
      delivery.delivery_date =
        delivery.deliveryDate &&
        formatDateObject(delivery.deliveryDate, "YYYY-MM-DD");
      delivery.delivery_type = "";
      if (delivery.deliveryType && delivery.deliveryType.length) {
        delivery.deliveryType.forEach((item) => {
          let atem = getEnumeration(item, deliverOptions);
          delivery.delivery_type = delivery.delivery_type ?
            delivery.delivery_type + "/" + atem :
            atem;
        });
      }
      console.log("result", result);
      return result;
    });
  },
  //样本数据重构
  getSampleMessage(val) {
    let data = {};
    data.orderProductDate = [];
    data.brand = [];
    data.specification_model = [];
    data.productBatchCode = [];
    data.productionUnit = [];
    data.color = [];
    data.shape = [];
    data.pack = [];
    data.storage = [];
    val.forEach((item) => {
      data.orderProduct_date_show = actions.arrayData(
        data,
        item,
        "orderProductDate",
        true
      );
      data.brand_show = actions.arrayData(data, item, "brand", true);
      data.specification_model = actions.arrayData(
        data,
        item,
        "specification_model"
      );
      data.productBatchCode_show = actions.arrayData(
        data,
        item,
        "productBatchCode",
        true
      );
      data.productionUnit_show = actions.arrayData(
        data,
        item,
        "productionUnit",
        true
      );
      data.sampleName_show = actions.arrayData(data, item, 'sampleName', true)
      data.sampleName_show_array = actions.arrayData(data, item, 'sampleName')
      data.shape = actions.arrayData(data, item, "shape");
      data.pack = actions.arrayData(data, item, "pack");
      data.storage = actions.arrayData(data, item, "storage");
      data.color_show = actions.arrayData(data, item, "color", true);
    });
    return data;
  },
  arrayData(data, item, key, isString) {
    let text = "";
    if (data[key] && data[key].indexOf(item[key] < 0)) {
      if (key === 'storage') {
        data[key] = item[key].split(',')
      } else {
        item[key] && data[key].push(item[key]);
      }
    }
    data[key] = Array.from(new Set(data[key])) //数组去重
    if (isString) {
      data[key].forEach((etem) => {
        text = text ? text + "/" + etem : etem;
      });
    }
    return isString ? text : data[key];
  },
  getTaskOrderMessage(ctx, id) {
    return fetch.getTaskOrderMessage(id).then((res) => {
      let result = res.data;
      result.issued_date =
        result.issuedDate && formatDateObject(result.issuedDate, "YYYY-MM-DD");
      result.completion_date =
        result.completionDate &&
        formatDateObject(result.completionDate, "YYYY-MM-DD");
      result.date_show =
        result.date && formatDateObject(result.date, "YYYY-MM-DD");
      result.examination_item_basis = "";
      result.examination_items = "";
      if (result.examinationItemBasis && result.examinationItemBasis.length) {
        result.examinationItemBasis.forEach((item) => {
          result.examination_item_basis = result.examination_item_basis ?
            result.examination_item_basis + "/" + item :
            item;
        });
      }

      if (result.examinationItems && result.examinationItems.length) {
        result.examinationItems.forEach((item) => {
          result.examination_items = result.examination_items ?
            result.examination_items + "," + item :
            item;
        });
      }
      console.log("result===", result);
      return result;
    });
  },
};
export default actions;